import { CButton, CCol, CLabel, CSelect } from "@coreui/react";
import Options from "./Options";
import ExportToExcelButton from "./controller/Button/ExportToExcelButton";

export const FilterSectionAfterSearch = (props) => {
  //const [isExporting, setIsExporting] = useState(false);
  //isExporting, usersData, ExportToExcel

  return (
    <>
      <CCol xl={6} sm={5} className={"mt-4"}>
        {/* <FilterSearchAndClear search={props.search} clear={props.clear} /> */}
        <CButton
          className=""
          color="success"
          onClick={props.search}
          disabled={props.isDisabledSearchClear}
        >
          Search
        </CButton>
        <CButton
          className="ml-3"
          color="danger"
          onClick={props.clear}
          disabled={props.isDisabledSearchClear}
        >
          Clear
        </CButton>
        {props.extraSearchControl}
      </CCol>
      <CCol xl={2} sm={1}>
        &nbsp;
      </CCol>
      <CCol xl={4} sm={6}>
        {props.isAfterSearchDataDisplay ? (
          props.items &&
          props.isDisplayItemPageDropDown && (
            <div className="float-right col-md-auto ">
              <CLabel className={"itemPerPage"}>Item Per Page</CLabel>
              <CSelect
                aria-label="Default select example"
                value={props.itemPerPage}
                onChange={props.onChangePage}
              >
                <Options />
              </CSelect>
            </div>
          )
        ) : (
          <div className="float-right col-md-auto ">
            <CLabel className={"itemPerPage"}>Item Per Page</CLabel>
            <CSelect
              aria-label="Default select example"
              value={props.itemPerPage}
              onChange={props.onChangePage}
            >
              <Options />
            </CSelect>
          </div>
        )}
        {props.isExportToExcelDisplay === true && (
          <div className="float-right mt-4 ">
            <ExportToExcelButton
              isExporting={props.isExporting}
              isDisabled={props.isDisabledExport}
              ExportToExcel={props.ExportToExcel}
            />
          </div>
        )}
      </CCol>
    </>
  );
};
